/**
 * Robin HQ / CM.com floating tab enhancements.
 * Robin injects #robin_tab_container at runtime, so we watch for it and
 * add a close (×) button that hides the tab via a body class (per session).
 */
(() => {
  'use strict';

  const HIDE_KEY = 'robinTabHidden';
  const CONTAINER_ID = 'robin_tab_container';

  const isHidden = () => {
    try {
      return sessionStorage.getItem(HIDE_KEY) === '1';
    } catch (err) {
      return false;
    }
  };

  const persistHidden = () => {
    try {
      sessionStorage.setItem(HIDE_KEY, '1');
    } catch (err) {
      /* storage unavailable — hide for this view only */
    }
  };

  const buildCloseButton = () => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'robin-close-btn';
    btn.setAttribute('aria-label', 'Verberg contactknop');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
      '</svg>';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.body.classList.add('robin-tab-hidden');
      persistHidden();
    });
    return btn;
  };

  const ensure = (container) => {
    if (!container.querySelector('.robin-close-btn')) {
      container.appendChild(buildCloseButton());
    }
  };

  const init = () => {
    if (isHidden()) {
      document.body.classList.add('robin-tab-hidden');
    }

    const existing = document.getElementById(CONTAINER_ID);
    if (existing) {
      ensure(existing);
    }

    // Robin can re-render the tab, so keep watching and re-inject if needed.
    const observer = new MutationObserver(() => {
      const container = document.getElementById(CONTAINER_ID);
      if (container) {
        ensure(container);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
